import { TbTrash, TbUpload } from 'react-icons/tb'
import toggle from './toggle.svg'
import classes from './pushDataTable.module.scss'

export default function PushDataTable() {
  return (
    <>
      <div className={classes.tableWrap}>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Domain</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Microsoft Corporation</td>
              <td>microsoft.com</td>
              <td>
                <div className={classes.buttonWrap}>
                  <div className={classes.button}>
                    <TbUpload />
                    Push to CRM
                  </div>
                  <div className={classes.deleteButton}>
                    <TbTrash />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>Apple Inc.</td>
              <td>apple.com</td>
              <td>
                <div className={classes.buttonWrap}>
                  <div className={classes.button}>
                    <TbUpload />
                    Push to CRM
                  </div>
                  <div className={classes.deleteButton}>
                    <TbTrash />
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>NVIDIA Corporation</td>
              <td>nvidia.com</td>
              <td>
                <div className={classes.buttonWrap}>
                  <div className={classes.button}>
                    <TbUpload />
                    Push to CRM
                  </div>
                  <div className={classes.deleteButton}>
                    <TbTrash />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={classes.divider}>and/or</div>
      <div className={classes.infoBlock}>
        <div className={classes.infoBlock__inner}>
          <img
            src={toggle.src}
            alt=''
            loading='lazy'
            width={40}
            height={24}
            aria-hidden='true'
          />
          <span className={classes.infoBlock__title}>
            Automatically Sync Notes
          </span>
          <p className={classes.infoBlock__caption}>
            Notes from a call are automatically added to your CRM once the call
            is processed
          </p>
        </div>
      </div>
    </>
  )
}
